import React from 'react';
import PropTypes from 'prop-types';
import {StaticQuery, graphql} from 'gatsby';
import Img from 'gatsby-image';

import Button from './Button';
import FlagList from './FlagList';

import styles from './About.module.scss';

const About = ({data}) => (
  <section className={styles.container}>
    <div className="wrap">
      <div className={styles.text}>
        <h2 className={styles.title}>
          <strong>Conheça a deputada</strong><br />
          Sâmia Bomfim
        </h2>

        <p><strong>Sâmia Bomfim tem 30 anos, foi vereadora de São Paulo e, atualmente, é deputada federal pelo PSOL.</strong> Elegeu-se com 250 mil votos, sendo a mais votada do partido e a oitava mais votada de todo o estado de São Paulo. Seu mandato jovem, feminista e antifascista levanta bandeiras que a maioria dos políticos não tem coragem de levantar. Ela é linha de frente no enfrentamento do conservadorismo e na oposição aos desmandos do governo Bolsonaro, defendendo sempre a maioria do povo.</p>
      </div>

      <Img className={styles.picture} fluid={data.pic.childImageSharp.fluid} style={{position: false}} />

      <div className={styles.text}>
        <h2 className={styles.title}>
          <strong>Nossas bandeiras</strong><br />
          na Câmara Federal
        </h2>

        <FlagList items={data.flags.edges.map(edge => edge.node.text)} />

        <p><Button to="/biografia/">Ler mais</Button></p>
      </div>
    </div>
  </section>
);

About.propTypes = {
  data: PropTypes.object,
};

const AboutWithData = () => (
  <StaticQuery
    query={graphql`
      query {
        pic: file(relativePath: { eq: "foto-bio.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 960) {
              ...GatsbyImageSharpFluid
            }
          }
        }

        flags: allFlagsJson(limit: 3) {
          edges {
            node {
              text
            }
          }
        }
      }
    `}
    render={data => <About data={data} />}
  />
);

export default AboutWithData;
